
export default {
    head() {
        // 优化seo：动态设置title，keywords 和 description
        return {
            title: 'Benefits for beginner artists',
            meta: [
                {
                    name: "keywords",
                    content:
                        "Benefits for beginner artists",
                },
                {
                    hid: 'description', name: 'names', content: 'Benefits for beginner artists'
                },
            ],
        };
    },
}
